import {
  FETCH_SHIFT_GROUPS, FETCH_SHIFT_GROUPS_SUCCESS, FETCH_SHIFT_GROUPS_FAILURE,
  CREATE_SHIFT_GROUP, CREATE_SHIFT_GROUP_SUCCESS, CREATE_SHIFT_GROUP_FAILURE,
  UPDATE_SHIFT_GROUP, UPDATE_SHIFT_GROUP_SUCCESS, UPDATE_SHIFT_GROUP_FAILURE,
  DELETE_SHIFT_GROUP, DELETE_SHIFT_GROUP_SUCCESS, DELETE_SHIFT_GROUP_FAILURE
} from "./actionTypes";

const initialState = {
  shiftGroups: [],
  loading: false,
  success:false,
  error: null,
};

const shiftGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIFT_GROUPS:
      return { ...state, loading: true };
    case FETCH_SHIFT_GROUPS_SUCCESS:
      return { ...state, loading: false, shiftGroups: action.payload.data };
    case FETCH_SHIFT_GROUPS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_SHIFT_GROUP:
      return { ...state, loading: true };
    case CREATE_SHIFT_GROUP_SUCCESS:
      return {
       ...state, loading: false, success:true, shiftGroup: action.payload, error: null };
    case CREATE_SHIFT_GROUP_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

    case UPDATE_SHIFT_GROUP_SUCCESS:
      return {
        ...state,
        shiftGroups: state.shiftGroups.map(shiftGroup =>
          shiftGroup.id === action.payload.id ? action.payload : shiftGroup
        )
      };

    case DELETE_SHIFT_GROUP:
      return { ...state, loading: true };
    case DELETE_SHIFT_GROUP_SUCCESS:
      return {
        ...state, loading: false, success:true, shiftGroup: action.payload, error: null 
      };
    case DELETE_SHIFT_GROUP_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default shiftGroupReducer;
